var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokMobileSound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 13,
  viewBox: "0 0 14 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M5.5 10.584V2.719L12 1.636V9h-1.917C8.985 9 8 9.616 8 10.584c0 .967.985 1.583 2.083 1.583h1.334c1.098 0 2.083-.616 2.083-1.583V.75a.75.75 0 0 0-.873-.74l-8 1.334a.75.75 0 0 0-.627.74v7.75H2.083C.985 9.834 0 10.449 0 11.417 0 12.384.985 13 2.083 13h1.334c1.098 0 2.083-.616 2.083-1.583v-.833"
})));
export default SvgTiktokMobileSound;